import { useEffect, useMemo, useState } from 'react';
import { DateTime } from 'luxon';
import { useLoading } from '../../../loading/LoadingContext';
import { apiFetch } from '../../../utility/fetch';
import { useUserContext } from '../../../user/UserContext';

export default function ShipWiseBatchRunsComponent () {
  const {toggleLoading} = useLoading()
  const {userData} = useUserContext()
  const [lastRefresh, setLastRefresh] = useState(DateTime.now().toLocaleString(DateTime.TIME_WITH_SECONDS))
  const [runs, setRuns] = useState(undefined)
  const [timingConfig, setTimingConfig] = useState(undefined)

  useEffect(() => {
    const load = async function() {
      toggleLoading(true)
      const configResponse = await apiFetch<any[]>({
        endpoint: 'azureTables',
        method: 'GET',
        accessToken: userData.accessToken,
        params: [{key: 'table', value: 'batchConfiguration'}]
      })
      const timingConfig = configResponse.body.find(c => c.partitionKey === 'timing')
      setTimingConfig(timingConfig)

      const timeOfDay: string[] = JSON.parse(timingConfig.timeOfDay)
      const runsResponse = await apiFetch<any[]>({
        endpoint: 'azureTables',
        method: 'GET',
        accessToken: userData.accessToken,
        params: [{key: 'table', value: 'batchRuns'}]
      })
      const runsRecords = []
      for(const record of runsResponse.body){
        if( timeOfDay.includes(decodeURIComponent(record.rowKey))  || decodeURIComponent(record.rowKey) === record.endTimeOfDay){
          runsRecords.push(record)
        }
      }
      setRuns(runsRecords)
      toggleLoading(false)
    }
    load()
  }, [lastRefresh])

  const view = useMemo(() => {
    if(!runs) return
    const runsMap = new Map()
    for(const run of runs){
      if(!runsMap.has(run.partitionKey)){
        runsMap.set(run.partitionKey, [])
      }
      runsMap.get(run.partitionKey).push(run)
    }

    const cards = []
    for(const key of runsMap.keys()){
      const rows = runsMap.get(key)
      cards.push(<div className='shipwise-card'>
        <span className='shipwise-header'>{key}</span>
        <hr/>
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
          {rows.map(r => (
            <div className='batch-run'>
              <span className='shipwise-title'>{decodeURIComponent(r.rowKey)}</span><br/>
              <span className='shipwise-label' style={{fontSize: '1.2em'}}>{DateTime.fromISO(r.timestamp).toFormat('MM/dd/yyyy t')}</span>
            </div>
          ))}
        </div>

      </div>)
    }

    const days = JSON.parse(timingConfig.daysOfWeek)
    const timesOfDay = [...JSON.parse(timingConfig.timeOfDay), timingConfig.endOfDayTime]
    return <div>
      <span className='shipwise-label'>View the last time configured runs happened here. Create a ticket if the days or times need to be changed.</span>
      <div className='shipwise-header'>
        Days
      </div>
      <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
        {days.map(d => (
          <div className='shipwise-label' style={{fontSize: '1.2em'}}>
            {d}
          </div>
        ))}
      </div>
      <div className='shipwise-header'>
        Times
      </div>
      <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
        {timesOfDay.map(t => (
          <div className='shipwise-label' style={{fontSize: '1.2em'}}>
            {t}
          </div>
        ))}
      </div>
      {cards}
    </div>
  }, [runs, timingConfig])

  return view
}